import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { GetServerSidePropsContext } from "next";
import Head from "next/head";
import { useTranslations } from "next-intl";
import SignUpForm from "@components/signup-form";
import { useRouter } from "next/router";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { CPagesPath } from "shared/models/const/pages-path";
import { en, es } from "@lang";
import createCanonicalUrl from "@helpers/removeparams";
import Layout from "@components/layout";

export async function getServerSideProps({
  locale,
  resolvedUrl,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
      url: resolvedUrl,
    },
  };
}

export default function RegisterPage(props: any) {
  const titleT = useTranslations("title-pages");
  const router = useRouter();
  const user = useAppSelector((state) => state.Auth.user);

  function onSignUpSuccess() {
    router.push(CPagesPath.es.home);
  }

  useEffect(() => {
    if (user) router.push(CPagesPath.es.profile);
  }, [user, router]);

  return (
    <Layout showFooter={true}>
      <Head>
        <title>{titleT("signup")}</title>
        <link
          rel="canonical"
          href={createCanonicalUrl(
            `${process.env.NEXT_PUBLIC_DOMAIN_URL}${props.url}`
          )}
          key="canonical"
        />
      </Head>
      <Center>
        <Content>
          <SignUpForm onSignUpSuccess={onSignUpSuccess} isPage={true} />
        </Content>
      </Center>
    </Layout>
  );
}

const Center = styled.div`
  display: grid;
  place-content: center;
  padding: 20px;

  @media (min-height: 1100px) {
    height: var(--main-height);
  }
`;

const Content = styled.div`
  background-color: white;
  max-width: 600px;
  padding: 70px 20px 20px;
  border-radius: 40px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.13);
  margin: 100px 0;
`;
